import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const CeremoniesReligieuses = () => {
  return <DynamicPageRenderer slug="evenements/ceremonies" />;
};

export default CeremoniesReligieuses;
